import React from 'react';

import styles from './Switch.module.css';

interface SwitchProps {
  checked: boolean;
  onChange: () => void;
  label?: string;
  labelPlacement?: 'top' | 'bottom' | 'start' | 'end';
}

export const Switch: React.FC<SwitchProps> = ({
  checked,
  onChange,
  label,
  labelPlacement = 'end',
}) => {
  return (
    <div className={`${styles.switchContainer} ${styles[labelPlacement]}`}>
      {label && (labelPlacement === 'top' || labelPlacement === 'start') && (
        <span className={styles.label}>{label}</span>
      )}
      <label className={styles.switch}>
        <input type="checkbox" checked={checked} onChange={onChange} />
        <span className={styles.slider} />
      </label>
      {label && (labelPlacement === 'bottom' || labelPlacement === 'end') && (
        <span className={styles.label}>{label}</span>
      )}
    </div>
  );
};
